import { createSlice } from '@reduxjs/toolkit';

const listSlice = createSlice({
  name: 'list',
  initialState: [],
  reducers: {
    hydrateList: (state, { payload }) => {
      return [...payload];
    },
    addToList: (state, { payload }) => {
      state.push(payload);
    },
    updateOnList: (state, { payload }) => {
      const index = state.findIndex((item) => item.case_id === payload.case_id);
      if (index !== -1) {
        state[index] = payload;
      }
    },
    removeFromList: (state, { payload }) => {
      return state.filter((listItem) => listItem.case_id !== payload);
    },
    clearList: () => {
      return [];
    },
  },
});

export const { hydrateList, addToList, updateOnList, removeFromList, clearList } = listSlice.actions;
export default listSlice.reducer;
